import {
  Button,
  Card,
  CardBody,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap"
import { fetchResources, fail } from "../../actions"

import axios from "axios"
import { Link } from "react-router-dom"
import { Loading, PageContainer } from "../../components"
import React from "react"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"

class OrderSalesId extends React.Component {
  state = {
    fetching: true,
    updating: false,
    success: false,
    error: false,
    salesOrderId: "",
    customerDefault: null,
    orderName: null,
    entitlements: [],
    entitlementStatus: {},
  }

  componentDidMount = async () => {
    this.props.fetchResources({ resource: "customers" })
    const { customerId, orderId } = this.props.match.params
    try {
      const [{ data }, { data: azureData }] = await Promise.all([
        axios.get(`/customers/${customerId}/orders/${orderId}/salesorderid`),
        axios.get(
          `/customers/${customerId}/orders/${orderId}/azureentitlements`
        ),
      ])
      this.setState({
        fetching: false,
        salesOrderId: data.salesOrderId || "",
        customerDefault: data.customerDefault,
        orderName: data.orderName,
        entitlements: (azureData.entitlements || []).map((e) => ({
          ...e,
          salesOrderId: e.salesOrderId || "",
        })),
      })
    } catch (error) {
      this.props.fail(null, error).then(() => this.setState({ fetching: false }))
    }
  }

  changeEntitlementSalesId = (entitlementId, value) => {
    this.setState({
      entitlements: this.state.entitlements.map((e) =>
        e.id === entitlementId ? { ...e, salesOrderId: value } : e
      ),
    })
  }

  saveEntitlement = async (entitlementId, salesId) => {
    const { customerId } = this.props.match.params
    this.setState({
      entitlementStatus: {
        ...this.state.entitlementStatus,
        [entitlementId]: "updating",
      },
    })
    try {
      await axios.post(
        `/customers/${customerId}/orders/${entitlementId}/salesorderid`,
        { salesId }
      )
      this.setState({
        entitlementStatus: {
          ...this.state.entitlementStatus,
          [entitlementId]: "success",
        },
      })
    } catch (error) {
      this.props.fail(null, error).then(() =>
        this.setState({
          entitlementStatus: {
            ...this.state.entitlementStatus,
            [entitlementId]: "error",
          },
        })
      )
    }
  }

  handleChange = ({ target }) => this.setState({ [target.name]: target.value })

  save = async (salesId) => {
    const { customerId, orderId } = this.props.match.params
    this.setState({ updating: true, success: false, error: false })
    try {
      await axios.post(
        `/customers/${customerId}/orders/${orderId}/salesorderid`,
        { salesId }
      )
      this.setState({
        updating: false,
        success: true,
        salesOrderId: salesId || "",
      })
    } catch (error) {
      this.props
        .fail(null, error)
        .then(() => this.setState({ updating: false, error: true }))
    }
  }

  render() {
    const { t, customer } = this.props
    const { customerId } = this.props.match.params
    const title = `${this.state.orderName || t("_order")} - ${
      customer == null ? "" : customer.companyName
    }`
    return (
      <PageContainer title={title} loading={this.state.fetching}>
        <Card>
          <CardBody>
            <Form
              onSubmit={(e) => {
                e.preventDefault()
                this.save(this.state.salesOrderId)
              }}
            >
              <FormGroup>
                <Label for="salesOrderId">{t("_orderSalesOrderId")}</Label>
                <Input
                  id="salesOrderId"
                  name="salesOrderId"
                  value={this.state.salesOrderId}
                  onChange={this.handleChange}
                  placeholder={
                    this.state.customerDefault
                      ? `${t("_usesCustomerDefault")}: ${
                          this.state.customerDefault
                        }`
                      : t("_usesCustomerDefault")
                  }
                />
              </FormGroup>
              {this.state.updating ? (
                <Loading small />
              ) : (
                <>
                  <Button
                    type="submit"
                    color={
                      this.state.success
                        ? "success"
                        : this.state.error
                        ? "danger"
                        : "primary"
                    }
                    className="mr-2"
                  >
                    {t("_update")}
                  </Button>
                  <Button
                    type="button"
                    color="secondary"
                    onClick={() => this.save("")}
                  >
                    {t("_clearSalesOrderId")}
                  </Button>
                </>
              )}
            </Form>
            {this.state.entitlements.length > 0 && (
              <>
                <hr />
                <h5>{t("_azureSubscriptions")}</h5>
                {this.state.entitlements.map((e) => (
                  <FormGroup key={e.id} className="d-flex align-items-center">
                    <Label
                      className="mb-0 mr-2"
                      style={{ minWidth: 250 }}
                      title={e.id}
                    >
                      {e.friendlyName || e.id}
                    </Label>
                    <Input
                      style={{ maxWidth: 200 }}
                      className="mr-2"
                      value={e.salesOrderId}
                      onChange={(ev) =>
                        this.changeEntitlementSalesId(e.id, ev.target.value)
                      }
                      placeholder={t("_usesCustomerDefault")}
                    />
                    <Button
                      size="sm"
                      color={
                        this.state.entitlementStatus[e.id] === "success"
                          ? "success"
                          : this.state.entitlementStatus[e.id] === "error"
                          ? "danger"
                          : "primary"
                      }
                      disabled={
                        this.state.entitlementStatus[e.id] === "updating"
                      }
                      onClick={() => this.saveEntitlement(e.id, e.salesOrderId)}
                    >
                      {t("_update")}
                    </Button>
                  </FormGroup>
                ))}
              </>
            )}
            <hr />
            <Link to={`/customers/${customerId}`}>{t("_back")}</Link>
          </CardBody>
        </Card>
      </PageContainer>
    )
  }
}

const mapStateToProps = (state, props) => {
  const customer = state.customers.customers.find(
    (i) => i.id.toString() === props.match.params.customerId
  )
  return { customer }
}

export default connect(mapStateToProps, { fetchResources, fail })(
  withTranslation()(OrderSalesId)
)
